import { type PaginatedResponse } from './types';

import { type AxiosCompatibleResponse } from '@/modules/http/types';

export function getNextPageParam<T>(
  lastPage: AxiosCompatibleResponse<PaginatedResponse<T>>
): string | undefined {
  return lastPage?.data.page_info?.has_more && lastPage?.data.page_info.last
    ? lastPage?.data.page_info.last
    : // we return undefined to signify that no new pages are available
      undefined;
}
